/** Search params used in the suppliers page. */
export const searchParametersSuppliers = {
    MANAGERS: 'managers',
    NAME: 'name',
}

/** Search params used in the supplier API. */
export const searchParametersSuppliersApi = {
    MANAGERS: 'client__id__in',
    NAME: 'name__icontains',
}
